module.exports = __webpack_public_path__ + "img/chris-yourcarsold-car-buyers-dealers-wangara-perth-wa.bf9ef0a1.jpg";